import { chakra } from "@chakra-ui/react";
import { ComponentProps } from "react";

import SlackHashLogo from "@/common/assets/slack-hash-logo.svg?react";

const ChakraSlackHashLogo = chakra(SlackHashLogo);

export type SlackConnectionIconProps = ComponentProps<
  typeof ChakraSlackHashLogo
> & {
  isDisabled?: boolean;
};

export function SlackConnectionIcon({
  boxSize = 4,
  isDisabled = false,
  ...boxProps
}: SlackConnectionIconProps) {
  return (
    <ChakraSlackHashLogo
      boxSize={boxSize}
      flexShrink={0}
      opacity={isDisabled ? 0.5 : 1}
      {...boxProps}
    />
  );
}
